import React from "react";
import useTranslation from "@hooks/use_translation";
import type { GhrTask } from "@/types/task";
import TaskCard from "./TaskCard";
import JobInfo from "./JobInfo";
import GHR_TASK_CONFIG from "@/config/ghr_task_config";

const config = GHR_TASK_CONFIG.AvailabilityTask;

interface TaskCardProps {
  task: GhrTask;
}

const AvailabilityTask: React.FC<TaskCardProps> = ({ task }) => {
  const { t } = useTranslation("tasks");

  return (
    <TaskCard
      icon={config.icon}
      task={task}
      title={t(config.titleKey)}
      body={<JobInfo task={task} />}
      actionHref={task.url}
      actionText={t(config.actionTextKey)}
      theme={{
        colors: {
          background: "bg-white",
          border: "border-gray-700",
          iconBackground: "bg-gray-500",
        },
      }}
      dismissable={false}
    />
  );
};

export default AvailabilityTask;
